function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.1,
  cx: 36,
  cy: 36,
  r: 36,
  fill: "url(#capture_svg__paint0_linear_1641_2751)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.046 10h13.908c6.623 0 9.024.69 11.445 1.984a13.5 13.5 0 015.617 5.617C61.31 20.02 62 22.423 62 29.046v13.908c0 6.623-.69 9.024-1.984 11.445a13.5 13.5 0 01-5.617 5.617C51.98 61.31 49.577 62 42.954 62H29.046c-6.623 0-9.024-.69-11.445-1.984a13.5 13.5 0 01-5.617-5.617C10.69 51.98 10 49.577 10 42.954V29.046c0-6.623.69-9.024 1.984-11.445a13.5 13.5 0 015.617-5.617C20.02 10.69 22.423 10 29.046 10z",
  fill: "url(#capture_svg__paint1_linear_1641_2751)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#capture_svg__clip0_1641_2751)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff"
}, React.createElement("path", {
  d: "M42 28h2v2h-2v-2zm2 4h-2v2h2v-2zm-2 4h2v2h-2v-2zm2 4h-2v2h2v-2zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zm-2-4h2v2h-2v-2zm2-4h-2v2h2v-2z",
  fillOpacity: 0.67
}), React.createElement("path", {
  d: "M39 18a1 1 0 00-1 1v34a1 1 0 102 0V19a1 1 0 00-1-1zm-19 8a3 3 0 013-3h12a1 1 0 100-2H23a5 5 0 00-5 5v20a5 5 0 005 5h12a1 1 0 100-2H23a3 3 0 01-3-3V26zm32 0a3 3 0 00-3-3h-6a1 1 0 110-2h6a5 5 0 015 5v20a5 5 0 01-5 5h-6a1 1 0 110-2h6a3 3 0 003-3V26zm-22 2v4l-4.673 1.669A2 2 0 0024 35.552V44a2 2 0 002 2h6v-4a2 2 0 012-2h2V26h-4a2 2 0 00-2 2zm4 0h-2v2h2v-2zm-2 4h2v2h-2v-2zm2 4h-2v2h2v-2zm-6 0h2v2h-2v-2zm2 4h-2v2h2v-2z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "capture_svg__paint0_linear_1641_2751",
  x1: 108,
  y1: 36,
  x2: 36,
  y2: -36,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6E7CFD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#BB66E8"
})), React.createElement("linearGradient", {
  id: "capture_svg__paint1_linear_1641_2751",
  x1: -16,
  y1: 36,
  x2: 36,
  y2: 88,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#C363E5"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#637EFF"
})), React.createElement("clipPath", {
  id: "capture_svg__clip0_1641_2751"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(18 18)",
  d: "M0 0h36v36H0z"
})));

var SvgCapture = function SvgCapture(props) {
  return React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgCapture;